(() => {
  'use strict';

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const textNodes = (root) => [...root.querySelectorAll('h1, h2, h3, h4, p, li')];

  const removePressHeading = (root) => {
    textNodes(root).forEach((node) => {
      if (!/^over matchboox[?!]?$/.test(normalize(node.textContent))) return;
      if (node.closest('#mb-press')) return;
      node.remove();
    });
  };

  const equalizeStoryRows = (root) => {
    root.querySelectorAll('div').forEach((row) => {
      if (row.children.length < 2 || !row.querySelector('img')) return;
      const hasText = [...row.children].some((child) => /^(div|section|article|p)$/i.test(child.tagName) && normalize(child.textContent).length > 40);
      if (hasText && (row.style.display === 'flex' || row.className.toString().match(/row|column|story/i))) row.classList.add('mb-story-equal');
    });
  };

  const removeCompactSection = (heading, root) => {
    const block = heading.closest('article, li, [class*="card"], [class*="section"]');
    if (block && block !== root && normalize(block.textContent).length < 900) {
      block.remove();
      return;
    }
    const next = heading.nextElementSibling;
    heading.remove();
    if (next && /^(p|div)$/i.test(next.tagName) && normalize(next.textContent).length < 700) next.remove();
  };

  const refineGiftService = (root) => {
    if (root.querySelector('.mb-gift-service__top')) {
      root.querySelectorAll('a[href="/pages/persoonlijke-boodschap"]').forEach((link) => {
        link.href = '/pages/cadeauservice';
      });
      return;
    }
    const nodes = textNodes(root);
    const stepOne = nodes.find((node) => /^stap\s*1\b/.test(normalize(node.textContent)));
    if (stepOne && !root.querySelector('.mb-gift-service-photo')) {
      const figure = document.createElement('figure');
      figure.className = 'mb-gift-service-photo';
      const image = document.createElement('img');
      image.src = root.dataset.giftServiceImage;
      image.alt = 'Eén losse MatchBoox in een doosje';
      image.loading = 'lazy';
      image.width = 1000;
      image.height = 905;
      figure.appendChild(image);
      const stepBlock = stepOne.closest('article, li, [class*="step"]') || stepOne;
      stepBlock.parentNode?.insertBefore(figure, stepBlock);
    }

    const replaceStepCopy = (number, text) => {
      const heading = textNodes(root).find((node) => new RegExp(`^stap\\s*${number}\\b`).test(normalize(node.textContent)) && /^h[1-4]$/i.test(node.tagName));
      if (!heading) return;
      const block = heading.closest('article, li, [class*="step"], [class*="card"]');
      const copy = block && block !== root
        ? [...block.querySelectorAll('p')].find((paragraph) => normalize(paragraph.textContent).length > 10)
        : (/^p$/i.test(heading.nextElementSibling?.tagName || '') ? heading.nextElementSibling : null);
      if (copy) copy.textContent = text;
    };
    replaceStepCopy(4, 'Vul het adres van de ontvanger in als bezorgadres. Gebruik uw eigen e-mailadres zodat u op de hoogte blijft van het bestel- en bezorgproces.');

    textNodes(root).forEach((node) => {
      const value = normalize(node.textContent);
      const isLeafText = !node.querySelector('p, li, h1, h2, h3, h4');
      if (/een complete serie cadeau (geven|doen)/.test(value)) {
        removeCompactSection(node, root);
        return;
      }
      if (isLeafText && value.includes('3,50') && (value.includes('shopify') || value.includes('automatisch') || value.includes('persoonlijke boodschap'))) {
        if (/^h[1-4]$/i.test(node.tagName)) return;
        node.textContent = node.textContent.replace(/\bShopify\b/gi, '').replace(/\s{2,}/g, ' ').replace(/\s+([.,])/g, '$1').trim();
        return;
      }
      if (isLeafText && (value.includes('adres van de ontvanger') || value.includes('bezorgadres'))) {
        if (/^h[1-4]$/i.test(node.tagName)) return;
        node.textContent = 'Vul het adres van de ontvanger in als bezorgadres. Gebruik uw eigen e-mailadres zodat u op de hoogte blijft van het bestel- en bezorgproces.';
        return;
      }
      if (isLeafText && value.includes('we voegen geen factuur toe')) node.remove();
    });

    const seen = new Set();
    [...root.querySelectorAll('p, li')].forEach((node) => {
      if (node.querySelector('p, li')) return;
      const value = normalize(node.textContent);
      if (!value || value.length < 35) return;
      if (seen.has(value)) node.remove();
      else seen.add(value);
    });

    const required = [
      'De toeslag van € 3,50 verschijnt als apart artikel en wordt maar één keer berekend, ongeacht het aantal woorden.',
      'Laat u het tekstveld leeg, dan wordt er geen toeslag toegevoegd.',
    ];
    const missing = required.filter((line) => !normalize(root.textContent).includes(normalize(line)));
    if (missing.length) {
      const info = document.createElement('div');
      info.className = 'mb-gift-service-info';
      missing.forEach((line) => {
        const paragraph = document.createElement('p');
        paragraph.textContent = line;
        info.appendChild(paragraph);
      });
      root.appendChild(info);
    }

    root.querySelectorAll('a').forEach((link) => {
      if (normalize(link.textContent).includes('vind het juiste cadeau')) link.href = '/pages/cadeauservice';
    });
  };

  const refineBestelInformation = (root) => {
    if (root.dataset.mbOrderSystem === 'true') return;
    let heading = textNodes(root).find((node) => normalize(node.textContent).includes('alles over bestellen, betalen en bezorgen'));
    if (!heading) {
      heading = document.createElement('h1');
      heading.textContent = 'Alles over bestellen, betalen en bezorgen';
    } else {
      heading.textContent = 'Alles over bestellen, betalen en bezorgen';
    }
    heading.classList.add('mb-page-standard-title');

    const image = root.querySelector('img');
    const imageBlock = image?.closest('figure, picture') || image;
    const topBlock = imageBlock && ([...root.children].find((child) => child === imageBlock || child.contains(imageBlock)) || imageBlock);
    const intro = textNodes(root).find((node) => normalize(node.textContent).includes('bestellen bij matchboox is eenvoudig en veilig'));
    const summary = document.createElement('section');
    summary.className = 'mb-order-summary-card';
    root.prepend(summary);
    summary.appendChild(heading);
    if (intro && intro !== heading) summary.appendChild(intro);
    if (topBlock && topBlock !== summary && !topBlock.contains(summary)) {
      topBlock.classList.add('mb-order-hero');
      summary.appendChild(topBlock);
    }
  };

  const removeOrderDimensions = (root) => {
    textNodes(root).forEach((node) => {
      if (!normalize(node.textContent).includes('formaat van losse boekjes en series')) return;
      const block = node.closest('.mbo-section, section, article') || node;
      if (block !== root) block.remove();
    });
  };

  const refineDisclaimer = (root) => {
    const native = root.querySelector('#mb-legal');
    if (!native) return;
    native.querySelector('#mbl-visual')?.remove();
    native.querySelector('#mbl-heading')?.remove();
    native.querySelector('#mbl-intro')?.remove();
  };

  const refineQuestionCopy = (root) => {
    [...root.querySelectorAll('label, button, input[placeholder], textarea[placeholder], h1, h2, h3, p')].forEach((node) => {
      if (node.hasAttribute('placeholder')) {
        node.placeholder = node.placeholder.replace(/\breactie\b/gi, 'vraag');
      } else if (!node.children.length) {
        node.textContent = node.textContent.replace(/\breactie\b/gi, (word) => word[0] === 'R' ? 'Vraag' : 'vraag');
      }
    });
  };

  const refineContact = (root) => {
    const imported = root.querySelector('.mb-contact-imported');
    const header = root.querySelector('.mb-contact-intro');
    if (!imported || !header) return;

    [...imported.querySelectorAll('h1, h2, h3, p')].forEach((node) => {
      if (node.querySelector('img, form, a, h1, h2, h3, p')) return;
      const value = normalize(node.textContent);
      const duplicateTitle = /^contact( met matchboox)?[.!]?$/.test(value);
      const duplicateIntro = value.startsWith('heeft u een vraag')
        || value.startsWith('voor vragen, bestellingen, samenwerkingen')
        || value.includes('nieuwe projecten en suggesties voor het fonds');
      if (duplicateTitle || duplicateIntro) node.remove();
    });

    [...imported.querySelectorAll('h1, h2, h3, h4')].forEach((heading) => {
      if (!/voorstel|nieuwe matchboox|idee voor het fonds/.test(normalize(heading.textContent))) return;
      removeCompactSection(heading, imported);
    });

    const image = imported.querySelector('img');
    if (image) {
      const imageBlock = image.closest('figure, picture') || image;
      const topBlock = [...imported.children].find((child) => child === imageBlock || child.contains(imageBlock)) || imageBlock;
      topBlock.classList.add('mb-contact-hero');
      image.alt = image.alt?.trim() ? `${image.alt.replace(/\s*[–-]\s*MatchBoox.*$/i, '')} – MatchBoox` : 'Opengevouwen MatchBoox-miniatuurboek';
      header.after(topBlock);
    }
  };

  const refinePersonalMessage = (root) => {
    const images = [...root.querySelectorAll('img')];
    if (!images.length) return;
    images[0].classList.add('mb-personal-message-hero');
    if (images[1]) {
      const block = images[1].closest('figure, picture');
      (block && !block.contains(images[0]) ? block : images[1]).remove();
    }
  };

  const refineMakerPage = (root) => {
    textNodes(root).forEach((node) => {
      if (node.querySelector('p, li, h1, h2, h3, h4')) return;
      const value = normalize(node.textContent);
      if (!(value.includes('bespreken we de vorm') || value.includes('we bespreken de vorm') || value.includes('testdruk') || value.includes('proefdruk'))) return;
      const block = node.closest('li, article, [class*="step"], [class*="card"]');
      (block && block !== root ? block : node).remove();
    });
  };

  const refineStoryImage = (root) => {
    const image = root.querySelector('img');
    if (image) {
      image.classList.add('mb-story-narrow-image');
      const frame = image.closest('figure, picture, [class*="image"], [class*="media"]');
      if (frame && frame !== root) frame.classList.add('mb-story-image-frame');
    }
  };

  const EDITORIAL_HANDLES = new Set([
    'wat-zijn-matchboox',
    'waarom-matchboox',
    'pers-en-media',
    'the-matchboox-story',
    'over-ons',
  ]);

  const hasNativePageLayout = (root) => [...root.children].some((child) => child.id?.startsWith('mb-'));

  const closestDirectChild = (node, wrapper) => {
    let current = node;
    while (current?.parentElement && current.parentElement !== wrapper) current = current.parentElement;
    return current?.parentElement === wrapper ? current : null;
  };

  const refineWhatOrWhy = (root, handle) => {
    const wrapper = root.querySelector(handle === 'wat-zijn-matchboox' ? '#mb-what-v17' : '#mb-why-v18');
    if (!wrapper || wrapper.dataset.mbV119 === 'true') return;

    if (handle === 'wat-zijn-matchboox') {
      const unwanted = textNodes(wrapper).find((node) => normalize(node.textContent).includes('vind de matchboox die bij u passen'));
      const unwantedBlock = unwanted && (unwanted.closest('section, article') || closestDirectChild(unwanted, wrapper));
      if (unwantedBlock && unwantedBlock !== wrapper) unwantedBlock.remove();
    }

    wrapper.querySelectorAll('.mb-v118-editorial-row, .mb-v118-editorial-row--reverse, .mb-v118-editorial-row--forward')
      .forEach((block) => block.classList.remove('mb-v118-editorial-row', 'mb-v118-editorial-row--reverse', 'mb-v118-editorial-row--forward'));

    const hero = wrapper.querySelector('.hero');
    const heroWrap = hero?.querySelector(':scope > .wrap');
    if (heroWrap) {
      heroWrap.classList.add('mb-v119-editorial-hero');
      wrapper.querySelectorAll('.mb-v118-editorial-usps').forEach((node) => node.remove());
      const usps = document.createElement('div');
      usps.className = 'mb-v119-editorial-usps';
      const labels = handle === 'wat-zijn-matchboox'
        ? ['20 pagina’s', 'Harmonicavorm', 'Handgemaakt', 'Om te lezen en bewaren']
        : ['Literatuur', 'Kunst', 'Kleine oplage', 'Unieke vorm'];
      labels.forEach((label) => {
        const item = document.createElement('span');
        item.textContent = label;
        usps.appendChild(item);
      });
      heroWrap.after(usps);
    }

    [...wrapper.querySelectorAll('.editorial-row, .makers-row, .small-format-row')].forEach((row, index) => {
      row.classList.add('mb-v119-editorial-row');
      row.classList.toggle('mb-v119-editorial-row--reverse', index % 2 === 1);
    });
    wrapper.dataset.mbV119 = 'true';
  };

  const refineStoryHero = (root) => {
    const wrapper = root.querySelector('#mb-story');
    if (!wrapper || wrapper.dataset.mbV119 === 'true') return;
    const hero = wrapper.querySelector('.mbs-hero');
    const figure = wrapper.querySelector('.mbs-image-wrap');
    if (!hero || !figure) return;
    const copy = document.createElement('div');
    copy.className = 'mb-v119-story-copy';
    [...hero.children].forEach((child) => copy.appendChild(child));
    hero.append(copy, figure);
    hero.classList.add('mb-v119-story-hero');
    const caption = wrapper.querySelector('.mbs-caption');
    if (caption) {
      figure.appendChild(caption);
      caption.style.setProperty('background-color', '#faf8f4', 'important');
    }
    wrapper.dataset.mbV119 = 'true';
  };

  const removeStorySpecialBlock = (root) => {
    const wrapper = root.querySelector('#mb-story') || root;
    const heading = [...wrapper.querySelectorAll('h1, h2, h3, h4')].find(
      (node) => normalize(node.textContent) === 'waarom matchboox bijzonder is'
    );
    if (!heading) return;

    const belongsToSpecialBlock = (node) => {
      const copy = normalize(node.textContent);
      return copy.includes('waarom matchboox bijzonder is')
        && copy.includes('persoonlijk kunstproject')
        && copy.includes('handgemaakt en geproduceerd');
    };

    let block = heading;
    let candidate = null;
    while (block.parentElement && block.parentElement !== wrapper) {
      block = block.parentElement;
      if (belongsToSpecialBlock(block) && normalize(block.textContent).length < 1200) candidate = block;
    }
    if (candidate) {
      candidate.remove();
      return;
    }

    let node = heading;
    while (node) {
      const next = node.nextElementSibling;
      if (node !== heading && node.matches('h1, h2, h3, h4')) break;
      node.remove();
      node = next;
    }
  };

  const refineMakersIntro = (root) => {
    const intro = root.querySelector('.mbw-video-intro');
    const grid = root.querySelector('.mbw-video-grid');
    [grid, intro].filter(Boolean).forEach((block) => {
      block.style.setProperty('width', 'min(1340px, 100%)', 'important');
      block.style.setProperty('max-width', '1340px', 'important');
      block.style.setProperty('margin-left', 'auto', 'important');
      block.style.setProperty('margin-right', 'auto', 'important');
    });
  };

  const refineEditorialPage = (root) => {
    /* Deze pagina's bevatten hun eigen, zorgvuldig opgebouwde blokken en CSS.
       Laat die structuur volledig intact. */
    if (hasNativePageLayout(root)) {
      root.classList.add('mb-native-page-layout');
      return;
    }
    if (root.querySelector('.mb-editorial-intro')) return;
    const image = root.querySelector('img');
    if (!image) {
      root.classList.add('mb-editorial-page', 'mb-editorial-page--no-image');
      return;
    }

    const intro = document.createElement('section');
    const copy = document.createElement('div');
    const media = document.createElement('div');
    intro.className = 'mb-editorial-intro';
    copy.className = 'mb-editorial-intro__copy';
    media.className = 'mb-editorial-intro__media';

    const heading = root.querySelector('h1, h2');
    if (heading) {
      const candidates = [...root.querySelectorAll('h1, h2, h3, p, ul, ol, blockquote, img')];
      const start = candidates.indexOf(heading);
      for (let index = start; index < candidates.length; index += 1) {
        const node = candidates[index];
        if (node === image) break;
        if (index > start && node.matches('h1, h2, h3')) break;
        if (node.contains(image)) continue;
        copy.appendChild(node);
      }
    }
    if (!copy.children.length) {
      const fallback = [...root.children].find((child) => !child.contains(image));
      if (fallback) copy.appendChild(fallback);
    }

    const formerImageParent = image.parentElement;
    media.appendChild(image);
    if (formerImageParent && formerImageParent !== root && !formerImageParent.textContent.trim() && !formerImageParent.children.length) {
      formerImageParent.remove();
    }

    intro.append(copy, media);
    root.prepend(intro);
    root.classList.add('mb-editorial-page');
    root.closest('.mb-page-shell')?.classList.add('mb-page-shell--editorial');
  };

  const init = () => {
    document.querySelectorAll('.mb-page-content[data-page-handle]').forEach((root) => {
      if (root.dataset.mbRefined === 'true') return;
      const handle = root.dataset.pageHandle;
      if (handle === 'pers-en-media') removePressHeading(root);
      if (handle === 'cadeauservice') refineGiftService(root);
      if (handle === 'bestelinformatie') refineBestelInformation(root);
      if (handle === 'bestelinformatie') removeOrderDimensions(root);
      if (handle === 'disclaimer') refineDisclaimer(root);
      if (handle === 'contact' || handle === 'stel-een-vraag') refineQuestionCopy(root);
      if (handle === 'contact') refineContact(root);
      if (handle === 'persoonlijke-boodschap') refinePersonalMessage(root);
      if (handle === 'word-zelf-maker') refineMakerPage(root);
      if (handle === 'wat-zijn-matchboox' || handle === 'waarom-matchboox') refineWhatOrWhy(root, handle);
      if (handle === 'the-matchboox-story') {
        refineWhatOrWhy(root, 'wat-zijn-matchboox');
        removeStorySpecialBlock(root);
        refineStoryHero(root);
      }
      if (handle === 'makers-vertellen') refineMakersIntro(root);
      if (EDITORIAL_HANDLES.has(handle)) refineEditorialPage(root);
      else if (handle === 'vind-het-juiste-cadeau' || handle === 'makers-vertellen' || handle === 'word-zelf-maker' || handle === 'bestelinformatie' || handle === 'disclaimer' || handle === 'cadeauservice') root.classList.add('mb-wide-page');
      else root.classList.add('mb-compact-page');
      root.dataset.mbRefined = 'true';
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
